import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Formik, useFormikContext } from 'formik';
import * as yup from 'yup';
import ArrowLeft from 'assets/icons/ic-arrow-left.svg';
import './Assessment.scss';
import { Tab, Tabs } from 'react-bootstrap';
import { TabContent } from 'components/common/TabContent';
import { getAssessment, postAssessment } from 'store/assessmentSingle/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'store';
import { IAssessmentSingleState } from 'store/assessmentSingle/types';
import { configureValidation, DISABLED_ASSESSMENT_STATUS_FLAG } from './config';
import TableLoader from 'components/TableLoader';
import { CompleteAssessment } from 'components/CompleteAssessment';
import { SaveAssessmentModal } from '../../components/SaveAssessmentModal';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';
import { translateText } from 'utils/helpers/useTranslation';
import { CONDITIONS } from 'utils/helpers/enum';
import { checkAllConditionsFollow } from 'utils/helpers/useCondition';
import { showField } from 'utils/helpers/showField';
import DownloadReportButton from 'components/DownloadReportButton';
import SavePopup from 'components/SavePopup';
import { formDataToPost } from 'utils/helpers/form.data.to.post';
import {
  createCleanGridField,
  createCleanField,
} from 'utils/helpers/field.helpers';
import { ResyncButton } from '../../components/ResyncButton';
import { ReviewButton } from '../../components/ReviewButton';
import Api from '../../api';
import {
  IUnitsMapping,
  UnitSystemKey,
} from 'utils/helpers/units.helpers';
import { isDevEnv } from 'utils/env';

const checkFeedStageSelected = (fieldName: string, data: any): boolean => {
  let feedIntakeField = null;

  if (data && Array.isArray(data)) {
    for (const assessment of data) {
      if (assessment.Pages) {
        for (const page of assessment.Pages) {
          if (page.Fields) {
            for (const field of page.Fields) {
              if (field.Template.DisplayName === 'Feed Intake') {
                feedIntakeField = field;
                break;
              }
            }
          }
          if (feedIntakeField) break;
        }
      }
      if (feedIntakeField) break;
    }
  }

  if (!feedIntakeField) {
    return true;
  }

  if (
    feedIntakeField.Template.FieldType.Name === 'Grid' &&
    feedIntakeField.GridChildren
  ) {
    let valuesList = null;
    if (
      feedIntakeField.GridChildren.length > 0 &&
      feedIntakeField.GridChildren[0].length > 0
    ) {
      const firstField = feedIntakeField.GridChildren[0][0];
      if (
        firstField.Template.Parameters &&
        firstField.Template.Parameters.ValuesList
      ) {
        valuesList = firstField.Template.Parameters.ValuesList;
      }
    }

    const selectedStageIds = [];
    feedIntakeField.GridChildren.forEach(row => {
      row.forEach(field => {
        if (
          field.Template.DisplayName === 'Feed Stages' &&
          field.Value &&
          field.Value !== null &&
          field.Value !== ''
        ) {
          selectedStageIds.push(field.Value);
        }
      });
    });

    const feedStageMapping: { [key: string]: string[] } = {
      'Pre-Lay 1': ['Pre-Lay 1'],
      'Pre-Lay 2': ['Pre-Lay 2'],
      'Pre-Lay 3': ['Pre-Lay 3'],
      'Early Lay 1': ['Early Lay 1'],
      'Early Lay 2': ['Early Lay 2'],
      'Early Lay 3': ['Early Lay 3'],
      'Peak Lay 1': ['Peak Lay 1'],
      'Peak Lay 2': ['Peak Lay 2'],
      'Peak Lay 3': ['Peak Lay 3'],
      'Late Lay 1': ['Late Lay 1'],
      'Late Lay 2': ['Late Lay 2'],
      'Late Lay 3': ['Late Lay 3'],
    };

    const matchingStages = feedStageMapping[fieldName];
    if (!matchingStages) {
      return true;
    }

    if (valuesList && valuesList.Values) {
      for (const stageName of matchingStages) {
        const stageValue = valuesList.Values.find(v => v.Name === stageName);
        if (stageValue && selectedStageIds.includes(stageValue.ID)) {
          return true;
        }
      }
    }
  }

  return false;
};

interface IInitialValues {
  [key: string]: string | object;
}

interface IValidationScheme {
  [key: string]: any;
}
interface IProps {
  setDoctId?: React.Dispatch<React.SetStateAction<any>>;
}
const Assessment = () => {
  const { uid } = useParams<{ uid: string }>();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [changedFieldsId, setChangedFieldsId] = useState([]);
  const [currentTab, setCurrentTab] = useState();


  const [formikVal, setFormikVal] = useState();
  const [newDataToPost, setNewDataToPost] = useState([]);
  const [shouldAvtoSave, setShouldAvtoSave] = useState(false);
  const [userHandleSaveData, setUserHandleSaveData] = useState(false);

  const [exitModalOpen, setExitModalOpen] = useState(false);
  const [isHaveErrors, SetIsHaveErrors] = useState(false);
  const { t } = useTranslation();

  const [currentAssesmentID, setCurrentAssesmentID] = useState(0);
  const [saveBeforeExitPopupOpen, setSaveBeforeExitPopupOpen] = useState(false);

  const isReadOnly =
    new URLSearchParams(location.search).get('readonly') === 'true';

  const { data, isLoading, error } = useSelector<
    IAppState,
    IAssessmentSingleState
  >(state => state.singleAssessment);
  const originalData = useSelector(
    (state: IAppState) => state.singleAssessment.originalData,
  );
  const [newData, setNewData] = useState(data);

  const [key, setKey] = useState('');
  const [packageKey, setPackageKey] = useState('');

  const [unitsMapping, setUnitsMapping] = useState<IUnitsMapping | null>(null);
  const [selectedUnitSystemKey, setSelectedUnitSystemKey] =
    useState<UnitSystemKey | null>(null);

  useEffect(() => {
    if (data.length > 1) {
      const firstVisibleTab = data?.find(
        el => el.Template.TemplatePageType !== 0,
      );
      if (!currentAssesmentID) {
        setCurrentAssesmentID(data[0]?.ID);
      }
      if (!packageKey) {
        setPackageKey(firstVisibleTab?.Template.Name);
      }
    } else {
      const firstVisibleTab = data?.[0]?.Pages.find(
        el => el.Template.TemplatePageType !== 0,
      );
      setCurrentAssesmentID(data[0]?.ID);
      if (key === '' || !key) {
        setKey(firstVisibleTab?.Template.Name);
      }
    }
  }, [data]);

  useEffect(() => {
    const loadUnits = async () => {
      try {
        const response = await Api(false).get('/api/Unit');
        const payload = response.data || [];

        const byId: IUnitsMapping['byId'] = {};
        const metricToImperial: IUnitsMapping['metricToImperial'] = {};
        const imperialToMetric: IUnitsMapping['imperialToMetric'] = {};
        const systemIdToKey: Record<number, UnitSystemKey> = {};

        payload.forEach((group: any) => {
          const sys = group?.UnitSystem;
          if (!sys || typeof sys.ID !== 'number') {
            return;
          }

          const rawName: string = sys.Name || '';
          const lowered = rawName.toLowerCase();
          const isMetric = lowered.includes('metric');
          const isImperial = lowered.includes('imperial');
          const systemKey: UnitSystemKey = isMetric
            ? 'metric'
            : isImperial
              ? 'imperial'
              : rawName;

          systemIdToKey[sys.ID] = systemKey;

          const units = (sys.Units || []) as any[];
          units.forEach(u => {
            if (typeof u.ID !== 'number') {
              return;
            }

            byId[u.ID] = {
              id: u.ID,
              postfixText: u.PostfixText ?? null,
              description: u.Description ?? null,
              system: systemKey,
            } as any;

            const links = (u.LinkedMeasures || []) as any[];
            links.forEach(link => {
              const rhsId = link?.RightHandSideID;
              if (typeof rhsId !== 'number') {
                return;
              }

              if (systemKey === 'metric') {
                metricToImperial[u.ID] = rhsId;
                imperialToMetric[rhsId] = u.ID;
              } else if (systemKey === 'imperial') {
                imperialToMetric[u.ID] = rhsId;
                metricToImperial[rhsId] = u.ID;
              }
            });
          });
        });

        setUnitsMapping({ byId, metricToImperial, imperialToMetric });

        const saved = localStorage.getItem('selectedUnitSystemId');
        if (saved) {
          const parsed = Number(saved);
          if (!Number.isNaN(parsed)) {
            const key = systemIdToKey[parsed];
            if (key) {
              setSelectedUnitSystemKey(
                typeof key === 'string' ? key.toLowerCase() : key,
              );
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    loadUnits();
  }, []);

  useEffect(() => {
    setKey(undefined);
  }, [packageKey]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [key, packageKey]);

  const [initialValues, validSchema] = useMemo(() => {
    const initial: IInitialValues = {};
    const validation: IValidationScheme = {};
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          if (field.Template.FieldType.Name === 'Grid') {
            const arrayOfFields = [];
            field.GridChildren.forEach(fieldArray => {
              const fieldsObject = {};
              fieldArray.forEach(f => {
                fieldsObject[f.Template.Name] = f.Value;
              });
              arrayOfFields.push(fieldsObject);
            });
            initial[field.Guid] = arrayOfFields;
          } else {
            initial[field.Guid] = field.Value || '';
          }
        });
      });
    });
    return [initial, validation];
  }, [data, newData]);

  useEffect(() => {
    if (uid) {
      dispatch(getAssessment(uid));
    }
  }, [dispatch, uid]);

  useEffect(() => {
    if (data && data.length > 0) {
      setNewData(data);
    }
  }, [data]);

  const onGoBack = (isFormTouched: any) => {
    if (data?.[0]?.StatusFlag === 2 || data?.[0]?.StatusFlag === 5) {
      history.goBack();
      return null;
    }
    if (!!Object.keys(isFormTouched).length) {
      setExitModalOpen(true);
    } else {
      history.goBack();
    }
  };

  const onModalAgree = async () => {
    await dispatch(getApiAssessment());
    setExitModalOpen(false);
    history.goBack();
  };

  const onModalCancel = () => {
    setExitModalOpen(false);
  };

  const haveErrorsHandler = () => {
    SetIsHaveErrors(true);
  };

  const saveFieldsData = (pData, values, changedFieldsId) => {
    console.log('saveFieldsData called with:', {
      pData,
      values,
      changedFieldsId,
    });
    const dataToPost = [];

    // Helper function to check if a field has actually changed
    const hasFieldChanged = (field, originalField) => {
      if (!originalField) return true; // New field

      if (field.Template.FieldType.Name === 'Grid') {
        // For grid fields, compare GridChildren values
        if (
          !originalField.GridChildren ||
          field.GridChildren.length !== originalField.GridChildren.length
        ) {
          return true;
        }

        for (let i = 0; i < field.GridChildren.length; i++) {
          const currentRow = field.GridChildren[i];
          const originalRow = originalField.GridChildren[i];

          if (!originalRow || currentRow.length !== originalRow.length) {
            return true;
          }

          for (let j = 0; j < currentRow.length; j++) {
            const currentField = currentRow[j];
            const originalFieldChild = originalRow[j];

            if (
              !originalFieldChild ||
              currentField.Value !== originalFieldChild.Value
            ) {
              return true;
            }
          }
        }
        return false;
      } else {
        // For non-grid fields, compare values
        const currentValue = values[field.Guid];
        const originalValue = originalField.Value;
        return currentValue !== originalValue;
      }
    };

    const processGridField = f => {
      // Find original grid field by Template ID across all pages
      let originalGridField = null;
      if (originalData && originalData[0] && originalData[0].Pages) {
        originalData[0].Pages.forEach(originalPage => {
          if (originalPage.Fields) {
            const foundField = originalPage.Fields.find(
              originalField => originalField.Template.ID === f.Template.ID,
            );
            if (foundField) {
              originalGridField = foundField;
            }
          }
        });
      }

      // Preserve existing IDs and generate new ones only for new fields
      f.GridChildren = f.GridChildren.map((row, rowIndex) =>
        row.map((field, fieldIndex) => {
          if (field.ID && typeof field.ID === 'number' && field.ID > 0) {
            return { ...field };
          }

          const originalFieldsMap = new Map();
          if (originalGridField?.GridChildren) {
            originalGridField.GridChildren.forEach((origRow, origRowIndex) => {
              origRow.forEach(origField => {
                const key = `${origField.Template.ID}_${origField.GridRow}`;
                originalFieldsMap.set(key, origField);
              });
            });
          }

          const key = `${field.Template.ID}_${field.GridRow}`;
          const originalField = originalFieldsMap.get(key);

          if (originalField && originalField.ID) {
            return { ...field, ID: originalField.ID };
          }

          // If not found by position, try to find by Template ID only (for new rows)
          const foundByTemplate = originalGridField?.GridChildren?.flat()?.find(
            origField => origField.Template.ID === field.Template.ID,
          );

          if (foundByTemplate && foundByTemplate.ID) {
            return { ...field, ID: foundByTemplate.ID };
          }

          const newId = Date.now() + Math.random();
          return { ...field, ID: newId };
        }),
      );
      f.GridChildren.forEach(fieldsArray => {
        if (fieldsArray && Array.isArray(fieldsArray)) {
          fieldsArray.forEach(field => {
            if (field && field.GridRow < f.GridChildren.length) {
              field.Value = (values[f.Guid] &&
                values[f.Guid][field.GridRow] &&
                values[f.Guid][field.GridRow][field.Template?.Name]) as
                | string
                | null;
            }
          });
        }
      });

      if (
        changedFieldsId &&
        Array.isArray(changedFieldsId) &&
        changedFieldsId.includes(f.Guid)
      ) {
        // Check if the field has actually changed
        const originalField = originalData?.[0]?.Pages?.find(page =>
          page.Fields?.some(field => field.Template.ID === f.Template.ID),
        )?.Fields?.find(field => field.Template.ID === f.Template.ID);

        if (hasFieldChanged(f, originalField)) {
          if (originalData && originalData[0] && originalData[0].Pages) {
            originalData[0].Pages.forEach(originalPage => {
              if (originalPage.Fields) {
                const foundField = originalPage.Fields.find(
                  originalField => originalField.Template.ID === f.Template.ID,
                );
              }
            });
          }

          // Create payload that matches the expected API format
          const cleanField = createCleanField(
            f,
            f.Template.FieldType.Name === 'Grid'
              ? f.GridChildren.map(row =>
                row.map(gridField => createCleanField(gridField)),
              )
              : [],
          );

          dataToPost.push(cleanField);
          setNewDataToPost([...dataToPost]);
        }
      }
    };

    const processField = f => {
      if (f.Template.FieldType?.Name === 'Grid') {
        processGridField(f);
      } else {
        if (
          changedFieldsId &&
          Array.isArray(changedFieldsId) &&
          changedFieldsId.includes(f.Guid)
        ) {
          // Check if the field has actually changed
          const originalField = originalData?.[0]?.Pages?.find(page =>
            page.Fields?.some(field => field.Template.ID === f.Template.ID),
          )?.Fields?.find(field => field.Template.ID === f.Template.ID);

          if (hasFieldChanged(f, originalField)) {
            // Create payload that matches the expected API format for non-grid fields
            const cleanField = createCleanField(
              f,
              [],
              values[f.Guid] as string,
            );

            dataToPost.push(cleanField);
            setNewDataToPost([...dataToPost]);
          }
        }
      }
    };

    if (data.length > 0) {
      data.forEach(pData => {
        pData?.Pages.forEach(p => {
          p.Fields.forEach(processField);
        });
      });
    } else {
      pData?.forEach(p => p?.Fields.forEach(processField));
    }
  };

  useEffect(() => {
    if (changedFieldsId.length > 0)
      saveFieldsData(currentTab, formikVal, changedFieldsId);
  }, [changedFieldsId, formikVal]);

  useEffect(() => {
    // Don't start autosave interval in readonly mode
    if (isReadOnly) {
      return;
    }

    let intervalId;

    intervalId = setInterval(() => {
      if (changedFieldsId.length > 0) {
        setShouldAvtoSave(true);
      }
    }, 60000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [changedFieldsId, isReadOnly]);

  const postAndGetAss = async () => {
    const dataToPost = [];

    const processFieldForSave = f => {
      if (f.Template.FieldType?.Name === 'Grid') {
        const visibleGridChildren = f.GridChildren.map(row =>
          row
            .filter(field => {
              const formikValue =
                formikVal &&
                typeof formikVal === 'object' &&
                field.Guid &&
                (formikVal as any)[field.Guid];
              const updatedValue =
                formikValue !== undefined ? formikValue : field.Value;

              const hasValue =
                updatedValue !== null &&
                updatedValue !== undefined &&
                updatedValue !== '';

              const visible = field.Template.InitiallyVisibleOnLoad;
              const noDisplayConditions =
                !field.Template.DisplayConditions ||
                field.Template.DisplayConditions.length === 0;
              const conditionToShow =
                visible ||
                (!visible && noDisplayConditions) ||
                (!visible &&
                  !noDisplayConditions &&
                  checkAllConditionsFollow(field, newData));
              const isShowField = showField(
                field.Template.Archived,
                field.Template.VisibleExternally,
              );

              let shouldShow;
              if (
                f.Template.DisplayName === 'General Ingredients' &&
                field.Template.DisplayName !== 'Feed'
              ) {
                shouldShow =
                  hasValue &&
                  checkFeedStageSelected(field.Template.DisplayName, newData);
              } else {
                shouldShow = conditionToShow && isShowField && hasValue;
              }

              return shouldShow;
            })
            .map(field => {
              const formikValue =
                formikVal &&
                typeof formikVal === 'object' &&
                field.Guid &&
                (formikVal as any)[field.Guid];
              const updatedValue =
                formikValue !== undefined ? formikValue : field.Value;

              return {
                ...field,
                Value: updatedValue,
              };
            }),
        ).filter(row => row.length > 0);

        const filteredGridChildren = visibleGridChildren.filter(row =>
          row.some(
            field =>
              field.Value !== null &&
              field.Value !== undefined &&
              field.Value !== '',
          ),
        );

        const cleanGridField = createCleanGridField(f, filteredGridChildren);

        dataToPost.push(cleanGridField);
      } else if (
        changedFieldsId &&
        Array.isArray(changedFieldsId) &&
        changedFieldsId.includes(f.Guid)
      ) {
        let value: string = f.Value;

        if (
          formikVal &&
          typeof formikVal === 'object' &&
          f.Guid &&
          Object.prototype.hasOwnProperty.call(formikVal, f.Guid)
        ) {
          const safeFormikVal = formikVal as Record<string, unknown>;
          const v = safeFormikVal[f.Guid];
          if (typeof v === 'string') {
            value = v;
          }
        }
        const cleanField = createCleanField(f, [], value);

        dataToPost.push(cleanField);
      }
    };

    if (data.length > 0) {
      data.forEach(pData => {
        pData?.Pages.forEach(p => {
          p.Fields.forEach(processFieldForSave);
        });
      });
    }

    await dispatch(postAssessment(dataToPost, true));

    // Silent reload after autosave — no spinner, no page flash
    if (!isDevEnv()) {
      if (uid) {
        await dispatch(getAssessment(uid, { silent: true }));
      }
    }

    setChangedFieldsId([]);
    setNewDataToPost([]);
    setShouldAvtoSave(false);
  };
  useEffect(() => {
    // Don't autosave in readonly mode
    if (isReadOnly) {
      return;
    }
    if (shouldAvtoSave && changedFieldsId.length > 0) {
      postAndGetAss();
    }
  }, [shouldAvtoSave, isReadOnly]);

  useEffect(() => {
    const form = document.getElementById('main-form123');
    form?.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
    if (changedFieldsId.length === 0) {
      setShouldAvtoSave(false);
    }
  }, [changedFieldsId, shouldAvtoSave]);

  const validateForm = (values: any) => {
    const errors: any = {};

    const currentDataWithValues = data.map(ass => ({
      ...ass,
      Pages: ass.Pages.map(page => ({
        ...page,
        Fields: page.Fields.map(field => ({
          ...field,
          Value: values[field.Guid] || field.Value,
        })),
      })),
    }));

    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          const visible = field.Template.InitiallyVisibleOnLoad;
          const noDisplayConditions =
            !field.Template.DisplayConditions ||
            field.Template.DisplayConditions.length === 0;
          const conditionToShow =
            visible ||
            (!visible && noDisplayConditions) ||
            (!visible &&
              !noDisplayConditions &&
              checkAllConditionsFollow(field, currentDataWithValues));

          if (conditionToShow) {
            if (field.Template.FieldType?.Name === 'Grid') {
              const gridData = values[field.Guid];
              if (gridData && Array.isArray(gridData)) {
                gridData.forEach((row, rowIndex) => {
                  if (row && typeof row === 'object') {
                    Object.keys(row).forEach(fieldName => {
                      const gridField = field.GridChildren.flat().find(
                        f => f.Template.Name === fieldName,
                      );
                      if (gridField && gridField.Template.Required) {
                        const fieldValue = row[fieldName];
                        if (!fieldValue || fieldValue === '') {
                          errors[`${field.Guid}.${rowIndex}.${fieldName}`] =
                            'This field is required';
                        }
                      }
                    });
                  }
                });
              }
            } else {
              const fieldValue = values[field.Guid];
              const validator = field.Template.Validator;

              if (field.Template.Required) {
                if (!fieldValue || fieldValue === '') {
                  errors[field.Guid] = 'This field is required';
                }
              }

              if (fieldValue && fieldValue !== '' && validator) {
                const discriminator = validator.Discriminator;

                switch (discriminator) {
                  case 'NumericValidator':
                    const numValue = parseFloat(fieldValue);
                    if (isNaN(numValue)) {
                      errors[field.Guid] = 'Must be a valid number';
                    } else {
                      if (
                        validator.Minimum !== undefined &&
                        numValue < validator.Minimum
                      ) {
                        errors[
                          field.Guid
                        ] = `Minimum value is ${validator.Minimum}`;
                      }
                      if (
                        validator.Maximum !== undefined &&
                        numValue > validator.Maximum
                      ) {
                        errors[
                          field.Guid
                        ] = `Maximum value is ${validator.Maximum}`;
                      }
                      if (
                        validator.IntegerOnly &&
                        !Number.isInteger(numValue)
                      ) {
                        errors[field.Guid] = 'Must be a whole number';
                      }
                    }
                    break;

                  case 'TextValidator':
                    if (
                      validator.MinimumLength !== undefined &&
                      fieldValue.length < validator.MinimumLength
                    ) {
                      errors[
                        field.Guid
                      ] = `Minimum length is ${validator.MinimumLength} characters`;
                    }
                    if (
                      validator.MaximumLength !== undefined &&
                      fieldValue.length > validator.MaximumLength
                    ) {
                      errors[
                        field.Guid
                      ] = `Maximum length is ${validator.MaximumLength} characters`;
                    }
                    break;

                  case 'DateTimeValidator':
                    const dateValue = new Date(fieldValue);
                    if (isNaN(dateValue.getTime())) {
                      errors[field.Guid] = 'Must be a valid date';
                    } else {
                      if (
                        validator.MinimumDate &&
                        dateValue < new Date(validator.MinimumDate)
                      ) {
                        errors[
                          field.Guid
                        ] = `Date must be after ${validator.MinimumDate}`;
                      }
                      if (
                        validator.MaximumDate &&
                        dateValue > new Date(validator.MaximumDate)
                      ) {
                        errors[
                          field.Guid
                        ] = `Date must be before ${validator.MaximumDate}`;
                      }
                    }
                    break;

                  case 'MultiSelectionFieldValidator':
                    if (Array.isArray(fieldValue)) {
                      if (
                        validator.MinRows !== undefined &&
                        fieldValue.length < validator.MinRows
                      ) {
                        errors[
                          field.Guid
                        ] = `Minimum ${validator.MinRows} selections required`;
                      }
                      if (
                        validator.MaxRows !== undefined &&
                        fieldValue.length > validator.MaxRows
                      ) {
                        errors[
                          field.Guid
                        ] = `Maximum ${validator.MaxRows} selections allowed`;
                      }
                    }
                    break;
                }
              }
            }
          }
        });
      });
    });

    return errors;
  };

  return (
    <>
      <div className="page-content">
        <div
          className={
            isHaveErrors
              ? `container-custom container assessment-container invalid ${isReadOnly ? 'readonly-mode' : ''
              }`
              : `container-custom container assessment-container ${isReadOnly ? 'readonly-mode' : ''
              }`
          }
        >
          <div className="row">
            <div className="col-12">
              {isLoading ? (
                <TableLoader />
              ) : error ? (
                <p>sorry we have some troubles, reload the page please</p>
              ) : (
                <>
                  <Formik
                    initialValues={initialValues}
                    validate={validateForm}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={() => console.log('')}
                  >
                    {formik => (
                      <form
                        id="main-form123"
                        onSubmit={e => {
                          e.preventDefault();
                          formik.handleSubmit(e);
                        }}
                      >
                        <div className="assessment-header">
                          <h2
                            className="assessment-name"
                            onClick={() => {
                              setUserHandleSaveData(true);
                              setShouldAvtoSave(false);
                              setSaveBeforeExitPopupOpen(true);
                            }}
                          >
                            <button className="assessment-back">
                              <img src={ArrowLeft} alt="arrow image" />
                            </button>
                            {data.length > 0 && data[0].Template.Name}
                          </h2>
                          <div className="assessment-toolbar">
                            {data?.[0]?.ID && (
                              <DownloadReportButton
                                assesmentID={currentAssesmentID || data[0].ID}
                                assessmentIDs={data.map(a => a.ID)}
                                isReadOnly={isReadOnly}
                                onBeforeSync={postAndGetAss}
                              />
                            )}
                            {!isReadOnly && (() => {
                              const activeAss = data.find(a => a.ID === currentAssesmentID) || data[0];
                              const activeDataP = activeAss?.Pages?.find(p => p.Template.TemplatePageType !== 0) || activeAss?.Pages?.[0];
                              return activeDataP ? (
                                <CompleteAssessment
                                  userHandleSaveData={userHandleSaveData}
                                  setUserHandleSaveData={setUserHandleSaveData}
                                  changedFieldsId={changedFieldsId}
                                  setChangedFieldsId={setChangedFieldsId}
                                  assessmentsId={currentAssesmentID || data[0]?.ID}
                                  isHaveErrors={haveErrorsHandler}
                                  dataP={activeDataP}
                                />
                              ) : null;
                            })()}
                          </div>
                        </div>
                        <div className="tabs-wrapper">
                          {data?.length > 1 ? (
                            <Tabs
                              transition={false}
                              onSelect={k => {
                                window.scrollTo(0, 0);
                                setPackageKey(k);
                              }}
                              activeKey={packageKey}
                              className="nav nav-tabs primary-tabs package-sticky-header-assesments"
                            >
                              {data?.map(
                                (ass, assesmentIndex) => {
                                  return (
                                    // ass.Template.TemplatePageType == 0 && (
                                    <Tab
                                      onEnter={() => {
                                        setCurrentAssesmentID(ass.ID);
                                        return null;
                                      }}
                                      className="nav-item nav-link"
                                      title={translateText(
                                        ass.Template.Name,
                                        data,
                                      )}
                                      eventKey={ass.Template.Name}
                                      key={ass.ID}
                                    >
                                      <div className="inner-tabs-wrapper">
                                        <Tabs
                                          transition={false}
                                          className="nav nav-tabs package-sticky-tabs"
                                          activeKey={key}
                                          onSelect={k => {
                                            window.scrollTo(0, 0);
                                            setKey(k);
                                          }}
                                        >
                                          {ass?.Pages.map((p, i) => {
                                            const noDisplayConditions =
                                              !p.Template.DisplayConditions ||
                                              p.Template.DisplayConditions
                                                .length < 1;
                                            const conditionToShow =
                                              noDisplayConditions ||
                                              (!noDisplayConditions &&
                                                checkAllConditionsFollow(
                                                  p,
                                                  newData &&
                                                  newData[assesmentIndex],
                                                ));

                                            return (
                                              p.Template.TemplatePageType !==
                                              0 &&
                                              conditionToShow && (
                                                <Tab
                                                  className="nav-item nav-link"
                                                  title={translateText(
                                                    p.Template.Name,
                                                    data,
                                                  )}
                                                  eventKey={p.Template.Name}
                                                  key={p.ID}
                                                >
                                                  <TabContent
                                                    newDataToPost={
                                                      newDataToPost
                                                    }
                                                    setUserHandleSaveData={
                                                      setUserHandleSaveData
                                                    }
                                                    newData={
                                                      newData &&
                                                      newData[assesmentIndex]
                                                    }
                                                    setFormikVal={setFormikVal}
                                                    setCurrentTab={
                                                      setCurrentTab
                                                    }

                                                    changedFieldsId={
                                                      changedFieldsId
                                                    }
                                                    setChangedFieldsId={
                                                      setChangedFieldsId
                                                    }
                                                    translations={
                                                      data?.[0]?.Template
                                                        .Translations
                                                    }
                                                    data={p}
                                                    fieldsDisabled={
                                                      isReadOnly ||
                                                      ass.StatusFlag ===
                                                      DISABLED_ASSESSMENT_STATUS_FLAG
                                                    }
                                                    pageNum={i}
                                                    assId={ass.ID}
                                                    unitsMapping={unitsMapping}
                                                    selectedUnitSystemKey={
                                                      selectedUnitSystemKey
                                                    }
                                                  >
                                                  </TabContent>
                                                </Tab>
                                              )
                                            );
                                          })}
                                        </Tabs>
                                      </div>
                                    </Tab>
                                  );
                                },
                                // ),
                              )}
                            </Tabs>
                          ) : (
                            <>
                              <Tabs
                                transition={false}
                                className="nav nav-tabs single-sticky-tabs"
                                activeKey={key}
                                onSelect={k => {
                                  window.scrollTo(0, 0);
                                  setKey(k);
                                }}
                              >
                                {data?.[0]?.Pages.map((p, i) => {
                                  const noDisplayConditions =
                                    p.Template.DisplayConditions.length < 1 ||
                                    p.Template.DisplayConditions === undefined ||
                                    p.Template.DisplayConditions === null;
                                  const conditionToShow =
                                    noDisplayConditions ||
                                    (!noDisplayConditions &&
                                      checkAllConditionsFollow(p, newData));

                                  if (p.Template.TemplatePageType !== 0) {
                                    if (conditionToShow) {
                                      return (
                                        <Tab
                                          onEnter={() => {
                                            setCurrentAssesmentID(data?.[0]?.ID);
                                            return null;
                                          }}
                                          className="nav-item nav-link"
                                          title={translateText(
                                            p.Template.Name,
                                            data,
                                          )}
                                          eventKey={p.Template.Name}
                                          key={p.ID}
                                        >
                                          {/* <SavePopup 
                                                   data={newData && newData[0]}
                                                    isOpen={saveBeforeExitPopupOpen} 
                                                    setIsOpen={setSaveBeforeExitPopupOpen} 
                                                    changedFieldsId={changedFieldsId} 
                                                    setChangedFieldsId={setChangedFieldsId} 
                                                    setUserHandleSaveData={setUserHandleSaveData} 
                                                  />  */}
                                          <TabContent
                                            setUserHandleSaveData={
                                              setUserHandleSaveData
                                            }
                                            setFormikVal={setFormikVal}
                                            setCurrentTab={setCurrentTab}
                                            changedFieldsId={changedFieldsId}
                                            setChangedFieldsId={
                                              setChangedFieldsId
                                            }
                                            initialValues={initialValues}
                                            translations={
                                              data?.[0]?.Template.Translations
                                            }
                                            data={p}
                                            newData={newData && newData[0]}
                                            setNewData={setNewData}
                                            fieldsDisabled={
                                              isReadOnly ||
                                              data?.[0].StatusFlag ===
                                              DISABLED_ASSESSMENT_STATUS_FLAG
                                            }
                                            pageNum={i}
                                            assId={data?.[0].ID}
                                            unitsMapping={unitsMapping}
                                            selectedUnitSystemKey={
                                              selectedUnitSystemKey
                                            }
                                          >
                                          </TabContent>
                                        </Tab>
                                      );
                                    }
                                  }
                                })}
                              </Tabs>
                            </>
                          )}
                        </div>
                        <div className="assessment-buttons">
                          {data?.length > 0 && (
                            <ReviewButton
                              assessmentId={data[0]?.ID}
                              reviewableAssessment={data[0]?.ReviewableAssessment}
                            />
                          )}
                        </div>
                        <SavePopup
                          data={newData.find(
                            assesment => assesment.ID === currentAssesmentID,
                          )}
                          isOpen={saveBeforeExitPopupOpen}
                          setIsOpen={setSaveBeforeExitPopupOpen}
                          changedFieldsId={changedFieldsId}
                          setChangedFieldsId={setChangedFieldsId}
                          setUserHandleSaveData={setUserHandleSaveData}
                        />
                      </form>
                    )}
                  </Formik>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <SaveAssessmentModal
        onSave={onModalAgree}
        onExit={onModalCancel}
        isOpen={exitModalOpen}
        text={t('AP_sav?')}
        primaryButtonText={t('AP_agree')}
        cancelButtonText={t('AP_cancel')}
      /> */}
    </>
  );
};

export { Assessment };
